import {SvgProps} from '@website/types';

export const AudiosIcon: React.FC<SvgProps> = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="10" fill="white" />

      <rect
        x="8.5"
        y="11.0713"
        width="3"
        height="8.92871"
        rx="1.5"
        fill="url(#paint0_linear_11041_2240)"
      />

      <rect
        x="18.5"
        y="16.1733"
        width="3"
        height="8.92871"
        rx="1.5"
        fill="url(#paint1_linear_11041_2240)"
      />

      <rect
        x="28.5"
        y="11.0713"
        width="3"
        height="8.92871"
        rx="1.5"
        fill="url(#paint2_linear_11041_2240)"
      />

      <path
        d="M13.5 12.5713C13.5 11.7429 14.1716 11.0713 15 11.0713C15.8284 11.0713 16.5 11.7429 16.5 12.5713V27.4287C16.5 28.2571 15.8284 28.9287 15 28.9287C14.1716 28.9287 13.5 28.2571 13.5 27.4287V12.5713Z"
        fill="url(#paint3_linear_11041_2240)"
      />

      <path
        d="M23.5 12.5713C23.5 11.7429 24.1716 11.0713 25 11.0713C25.8284 11.0713 26.5 11.7429 26.5 12.5713V27.4287C26.5 28.2571 25.8284 28.9287 25 28.9287C24.1716 28.9287 23.5 28.2571 23.5 27.4287V12.5713Z"
        fill="url(#paint4_linear_11041_2240)"
      />

      <defs>
        <linearGradient
          id="paint0_linear_11041_2240"
          x1="10"
          y1="11.0713"
          x2="10"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop offset="1" stopColor="#F8E8F0" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_11041_2240"
          x1="20"
          y1="16.1733"
          x2="20"
          y2="25.1021"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop offset="1" stopColor="#F8E8F0" />
        </linearGradient>

        <linearGradient
          id="paint2_linear_11041_2240"
          x1="30"
          y1="11.0713"
          x2="30"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop offset="1" stopColor="#F8E8F0" />
        </linearGradient>

        <linearGradient
          id="paint3_linear_11041_2240"
          x1="15"
          y1="11.0713"
          x2="15"
          y2="28.9287"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop offset="1" stopColor="#F8E8F0" />
        </linearGradient>

        <linearGradient
          id="paint4_linear_11041_2240"
          x1="25"
          y1="11.0713"
          x2="25"
          y2="28.9287"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop offset="1" stopColor="#F8E8F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
